<template>
  <div>
    <zj-layout-container>
      <zj-layout-header style="paddingtop: 50px">
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="接收人">
            <el-select v-model="receiveUserId" placeholder="请选择">
              <el-option key="" label="全部" value=""></el-option>
              <el-option v-for="item in userList" :key="item.userId" :label="item.name"
                :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="任务状态">
            <el-select v-model="taskStatus" placeholder="请选择">
              <el-option key="" label="全部" value=""></el-option>
              <el-option v-for="item in dict.type.integrated_task_status" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="日期" prop="">
            <el-date-picker v-model="chooseStartDate" type="date" format="yyyy-MM-dd" :clearable="false"
              @change="changeBegin" placeholder="选择日期">>
            </el-date-picker>
            <span style="margin-left: 30px">结束时间：</span>
            <el-date-picker v-model="chooseEndDate" type="date" format="yyyy-MM-dd" :clearable="false"
              @change="changeEnd" placeholder="选择日期">>
            </el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="任务地址" prop="CarParkName">
            <el-input v-model="CarParkName" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="下发时间" prop="CarParkName">
            <el-input v-model="CarParkName" placeholder="请输入名称"></el-input>
          </el-form-item> -->

          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>

      </zj-layout-header>
      <zj-layout-main>
        <div class="echart">
          <div class="echart_1">           
          <PieEchartsTicket title="" xAxisName="" yAxisName="" :chartData="taskData"></PieEchartsTicket>

          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>
<script>
import { urbanUserList, taskList, taskSupervise } from "@/api/src/urbanServerApi";
export default {
  controller: "UI",
  action: "TaskCenterStatics",
  name: "TaskCenterStatics",
  dicts: ["integrated_task_status"],
  data() {
    return {
      chooseStartDate: new Date().format("yyyy-MM-dd"),
      chooseEndDate: new Date().format("yyyy-MM-dd"),
      taskData: [
        { "name": "已完成", value: 70 },
        { "name": "逾期", value: 30 }
      ],
      groupData: [],
      ageData: {},
      ticketTypeData: [],
      params: {
        district: this.CNF("app.districtCode"),
        districtCode: this.CNF("app.districtCode"),
        polityType: 3,
        timeType: "year",
        timeValue: 1,
      },
    };
  },
  mounted: function () {
    this.searchUserList();
    this.search();
  },
  methods: {
    changeBegin() {
      if (this.chooseStartDate && this.chooseEndDate) {
        if (
          new Date(this.chooseStartDate).getTime() >
          new Date(this.chooseEndDate).getTime()
        ) {
          this.chooseStartDate = "";
          this.$message({
            type: "warning",
            message: "开始时间不能大于结束时间",
          });
        }
      }
    },
    changeEnd() {
      if (this.chooseStartDate && this.chooseEndDate) {
        if (
          new Date(this.chooseStartDate).getTime() >
          new Date(this.chooseEndDate).getTime()
        ) {
          this.chooseEndDate = "";
          this.$message({
            type: "warning",
            message: "开始时间不能大于结束时间",
          });
        }
      }
    },
    searchUserList() {
      let that = this;
      urbanUserList().then(res => {
        if (res.code == 200) {
          that.userList = res.data || []
        }
      })
    },
    search() {
      let searchInfo = {
        receiveUserId: this.receiveUserId,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        status: this.taskStatus,
        search: "",
        // startTime:this.chooseStartDate,
        // endTime:this.chooseEndDate,
      };
      taskList(searchInfo).then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.tableData = res.rows;
          this.total = res.total;
          console.log(this.tableData)
        }
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.datelabel {
  border-right: 3px solid #2bc5ff;
  padding: 0 1rem;
}

.echart {
  position: relative;
  width: 100%;
  height: 100%;
}
.echart_1 {
  width: 40%;
  height: 70%;
}

.echart_1 {
  margin-bottom: 15px;
}

.echart_2 {
  margin-top: 15px;
}

.echart_1>div,
.echart_2>div {
  float: left;
  width: 30%;
  height: 100%;
  color: #2bc5ff;
  font-weight: bold;
  text-align: center;
}

.echart_2>div {
  width: 50%;
}
</style>